import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
    return (
        <footer data-testid="footer" className="bg-black border-t border-white/5 mt-32">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="font-display text-2xl tracking-wider mb-4">
                        ARNOUX <span className="text-[#C5A059]">&amp;</span> CO <span className="text-[#A3A39D] text-base tracking-widest">TAXI</span>
                    </div>
                    <p className="text-[#A3A39D] text-sm leading-relaxed max-w-md">
                        Service de chauffeur premium 24h/24, 7j/7. Discrétion, ponctualité et excellence depuis nos débuts.
                    </p>
                    <div className="mt-8 gold-divider w-24" />
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-6">Contact</div>
                    <ul className="space-y-3 text-sm text-[#A3A39D]">
                        <li className="flex items-center gap-3"><Phone size={14} /> <a href="tel:+33603349423" className="hover:text-[#C5A059]">06 03 34 94 23</a></li>
                        <li className="flex items-center gap-3"><Mail size={14} /> <a href="mailto:danyarnoux81@hotmail.com" className="hover:text-[#C5A059]">danyarnoux81@hotmail.com</a></li>
                        <li className="flex items-center gap-3"><MapPin size={14} /> France</li>
                        <li className="flex items-center gap-3"><Clock size={14} /> 24h/24 — 7j/7</li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-6">Liens</div>
                    <ul className="space-y-3 text-sm text-[#A3A39D]">
                        <li><a href="/reservation" className="hover:text-[#C5A059]">Réservation</a></li>
                        <li><a href="#services" className="hover:text-[#C5A059]">Nos services</a></li>
                        <li><a href="#contact" className="hover:text-[#C5A059]">Contact</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5 py-6 text-center text-xs text-[#A3A39D] tracking-[0.2em] uppercase">
                © {new Date().getFullYear()} Arnoux &amp; co Taxi — Tous droits réservés
            </div>
        </footer>
    );
};
